import React from 'react';
import { Empty, message } from 'antd';
import PaginationTable from '../../../shared/PaginationTable';
import { getRegionGroupColumns } from '../RegionListColumn.js';

export default function RegionGroupListView({
  regionGroups: { regionGroups },
  currentPage,
  onDeleteRegionGroup,
  toggleForm,
  setCurrentRegion,
  handleSubmitRegionGroup,
  selectedOrg,
  currentuser,
}) {
  const handleEdit = (region) => {
    setCurrentRegion(region);
    toggleForm(true);
  };

  const handleCopy = async (val) => {
    message.loading('Action in progress...', 0);
    console.log(val);
    let payload = {
      name: 'Copy of ' + val.name,
      regions: val.regions,
      isPresetList: val.isPresetList,
    };

    let request = null;
    request = handleSubmitRegionGroup;

    await request(payload)
      .then(() => {
        message.destroy();
        message.success(`Successfully cloned Region Group`);
      })
      .catch((err) => {
        message.destroy();
        message.error('Something went wrong');
      });
  };

  const columns = getRegionGroupColumns(
    handleEdit,
    onDeleteRegionGroup,
    handleCopy,
    currentuser,
    selectedOrg
  );

  return (
    <>
      {regionGroups && regionGroups.length > 0 ? (
        <PaginationTable
          columns={columns}
          data={regionGroups.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))}
          scroll={{ x: 800, y: 600 }}
          bordered={false}
          paginationSize={'default'}
          size={'default'}
          current={currentPage}
          pageSize={10}
          rowKey="id"
        />
      ) : (
        <Empty />
      )}
    </>
  );
}
